export const QUICK_BUY_REQUEST_DRAFT_KEY = "b2b_quick_buy_request_draft";

export function saveQuickBuyRequestDraft(draft) {
  try {
    sessionStorage.setItem(QUICK_BUY_REQUEST_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // Ignore storage failures.
  }
}

export function readQuickBuyRequestDraft() {
  try {
    const raw = sessionStorage.getItem(QUICK_BUY_REQUEST_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearQuickBuyRequestDraft() {
  try {
    sessionStorage.removeItem(QUICK_BUY_REQUEST_DRAFT_KEY);
  } catch {
    // Ignore storage failures.
  }
}
